import React, { useContext, useState, useEffect } from 'react'
import styled from 'styled-components'
import { IntakeContext } from 'context/IntakeContext'
import { useLocation } from 'react-router-dom'

const StyledScrollDownIndicator = styled.div`
  position: fixed;
  bottom: ${({ bottom }) => (bottom ? bottom : '0px')};
  width: 100%;
  z-index: 1;

  ::before {
    animation: bounce 1s ease infinite;
    bottom: 3rem;
    color: black;
    content: '╲╱';
    font-size: 2rem;
    height: 4rem;
    left: 50%;
    letter-spacing: -1px;
    line-height: 4rem;
    margin-left: -3rem;
    opacity: 0.8;
    position: absolute;
    text-align: center;
    width: 6rem;
  }

  @keyframes bounce {
    50% {
      transform: translateY(-50%);
    }
  }
`
export const ScrollDownIndicator = () => {
  const [isMobile, setIsMobile] = useState(false)
  const { loading } = useContext(IntakeContext)
  const location = useLocation()
  const isOnboarding = location.pathname.includes('/onboarding')
  const [showIndicator, setShowIndicator] = useState(false)

  // Detect if the device is mobile based on the screen width
  useEffect(() => {
    const checkIfMobile = () => {
      const screenWidth = window.innerWidth
      // Assuming a mobile device has a width of 768px or less
      setIsMobile(screenWidth <= 768)
    }

    checkIfMobile()
    // Add a resize event listener to handle changes in screen size
    window.addEventListener('resize', checkIfMobile)

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])

  // Check if there's more content to scroll to
  useEffect(() => {
    if (loading) return
    let scrollTimeout
    const checkForMoreContent = (e) => {
      if (e?.type === 'scroll') {
        clearTimeout(scrollTimeout)
        setShowIndicator(false)
      }
      // Set a new timeout
      const newTimeout = setTimeout(() => {
        const hasMoreContent =
          document.body.offsetHeight > window.innerHeight + window.scrollY
        setShowIndicator(hasMoreContent)
      }, 2000) // Adjust the time (in milliseconds) based on your needs

      scrollTimeout = newTimeout
    }

    // Initial check and set up event listeners for scroll and resize events
    checkForMoreContent()
    window.addEventListener('scroll', checkForMoreContent)
    window.addEventListener('resize', checkForMoreContent)

    return () => {
      clearTimeout(scrollTimeout)
      window.removeEventListener('scroll', checkForMoreContent)
      window.removeEventListener('resize', checkForMoreContent)
    }
  }, [loading, location.search])

  // Conditionally render the "scroll down" indicator
  if (isMobile && showIndicator) {
    return <StyledScrollDownIndicator bottom={isOnboarding ? '5px' : null} />
  } else {
    return null
  }
}
